// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-pareto';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm6.5 12v7H3v-7h3.5Zm6 3v4H9v-4h3.5Zm6 2v2H15v-2h3.5ZM16.75 2a1.75 1.75 0 1 1-1.572 2.52l-2.692.45a1.75 1.75 0 0 1-2.853 1.127l-3.21 2.14a1.75 1.75 0 1 1-.556-.834l3.21-2.14a1.75 1.75 0 0 1 3.245-1.283l2.692-.45A1.75 1.75 0 0 1 16.75 2Zm-12 6a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-4a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-1a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z' />
);

export const viewBox = '0 0 22 22';
